// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Labf","name":"Header_name__sJkzF","birthday":"Header_birthday__3-WGb","skeleton":"Header_skeleton__2d4LD"};